var map = {
	"./collage.jpg": "c086",
	"./collage.webp": "77ce",
	"./formulastudent.jpg": "f982",
	"./formulastudent.webp": "7d04",
	"./team.jpeg": "fc21",
	"./team.webp": "1be0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e1e";